import React from 'react'


import "./Room.css";


import hallfrontview from "../images/berhampore resort.jpg";
import corporatemeetinghal from "../images/corporate_meeting hall.jpg";

import Venus101slide from '../inc/Venus101slide.js';
import CorporateSlider from '../inc/CorporateSlider.js';


function Corporate() {

  return (
    <div>

      
      
   <CorporateSlider/>
      <br />


      <center>
        <div className='fonts'>
          <div className='album py-0'>
            <div className='container'>
              <div className='veva'>
                <h1><b>CORPOARTE MEETING HALL</b></h1>

              </div>
            </div>
          </div>
        </div>
      </center>



  





      <div className='album py-3'>
        <div className='container'>

          <div className="card mb-3" >
            <div className="row g-0">
              <div className="col-md-4">
                <img src={hallfrontview} className="img-fluid rounded-start" alt="hallfrontview"/>
              </div>
              <div className="col-md-8">
                <div className="card-body">
                  <div className='veva101'>
                    <h4 className="card-title mb-0"><b>CORPORATE HALL <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                      <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                    </svg></b></h4>
                  </div>
                  <p className="card-text mb-1">Category - Ac Dj Sound Hall, Best Luxury Clean AC Hall in Berhampore</p>
                  <a href='https://g.co/kgs/bGYUqH7' target="_blank" rel="noopener noreferrer">
                    <button className='direction mb-2'><small>View Direction <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-sign-merge-left" viewBox="0 0 16 16">
                      <path d="M7.25 6v1q-.211.451-.588.95c-.537.716-1.259 1.44-2.016 2.196l.708.708.015-.016c.652-.652 1.33-1.33 1.881-2.015V12h1.5V6h1.216a.25.25 0 0 0 .192-.41L8.192 3.23a.25.25 0 0 0-.384 0L5.842 5.59a.25.25 0 0 0 .192.41z" />
                      <path d="M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098zm-1.4.7a.495.495 0 0 1 .7 0l6.516 6.515a.495.495 0 0 1 0 .7L8.35 14.866a.495.495 0 0 1-.7 0L1.134 8.35a.495.495 0 0 1 0-.7L7.65 1.134Z" />
                    </svg></small></button>
                  </a>
                  
                  <h5 className='mb-2'>Corporate Meeting Booking - <b>Price after discuss </b> + GST</h5>




             

                  <a href='tel: 9046258703 '>
                    <button className="button10 button11 me-2">Call Now</button>
                  </a>


                  {/* <button type="button" className="button10 button11" data-bs-toggle="modal" data-bs-target="#exampleModal">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-check2-square" viewBox="0 0 16 16">
                      <path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5z" />
                      <path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0" />
                    </svg> VIEW PHOTOS (1)
                  </button>
                  <a href='tel: +919734448444'>
                    <button className="button10 button11 me-2">Book Now</button>
                  </a>


                  <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">

                          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                     
                        </div>
                        <div className="modal-footer">
                          <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                        </div>
                      </div>
                    </div>
                  </div> */}



                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Facility/> */}
      <br />
 
     







    </div>
  )
}

export default Corporate